import React, { useEffect, useState, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Signuptogetstarted from "../Signuptogetstarted";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import {
  checkMobile,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import { useNavigate, useLocation } from "react-router";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { GetCountry } from "../../../../redux/master/action";
import ReactSelect from "react-select";
import { uploadImage } from "../../../../CloudStorage/uploadImage";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import "react-phone-input-2/lib/style.css";
import VerifyEmailMobile from "../VerifyEmailMobile/VerifyEmailMobile";
import { scrollToTop } from "../../../../CloudStorage/CommonFunction";
import PopupPrivacyPolicy from "../../../Common/PopupPrivacyPolicy";
import { Modal } from "reactstrap";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { disabledStyle } from "../../../Common/ClickDisable";
import PhoneInputforSignUp from "./PhoneInputforSignUp";
import { handleNameKeyDown, notallowspace } from "../../../Common/FewCommonMethods";
import ProfileImageUpload from "./ProfileImageUpload";
import { mobilenumbervalidation, namevalidation, passwordvalidation, titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { detectCountryFromIP } from "../../../../utils/detectCountryFromIP";
import { isHttpImageUrl, uploadRemoteImage } from "../../../../utils/uploadRemoteImage";
import messageicon from "../../../../assests/imgs/annotation-dots.svg";
import whatsappicon from "../../../../assests/imgs/message-text-circle-02.svg";

const validationSchema = Yup.object().shape({
  first_name: namevalidation,
  last_name: namevalidation,
  mobile_number: mobilenumbervalidation,
  email_id: Yup.string()
    .email("Invalid email format")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email format")
    .required("Email is required"),
  password: passwordvalidation,
  conformpassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  country_code: Yup.string().required("Country code is required"),
  country_id: Yup.string().required("Country is required"),
  agree: Yup.boolean().oneOf(
    [true],
    "You must agree to the terms and conditions"
  ),
});

export default function SignUp() {
  const location = useLocation();
  const statevalues = location?.state;
  const [selectCountry, setSelectCountry] = useState("");
  const [nextpage, setNextpage] = useState(true);
  const [valuess, setValuess] = useState(null);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [selectedImage, setSelectedImage] = useState(
    statevalues?.profile_image || statevalues?.image || statevalues?.profile_image || statevalues?.image
  );

  const [modal, setModal] = useState(null);
  const dispatch = useDispatch();

  // Added ref to track which button was clicked (SMS or WhatsApp)
  const isWhatsappRef = useRef(0);

  const [selectCountryCode, setSelectCountryCode] = useState("");

  useEffect(() => {
    detectCountryFromIP().then((res) => {
      setSelectCountryCode(res.dial_code || '+91');
    });
  }, []);

  const navigate = useNavigate();
  const path = "Assets/scss/FirstTimeUsers.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(GetCountry());
  }, [path, dispatch]);

  const initialValues = {
    first_name: valuess?.first_name || statevalues?.first_name,
    last_name: valuess?.last_name || statevalues?.last_name,
    mobile_number: valuess?.mobile_number,
    email_id: valuess?.email_id || statevalues?.email_id,
    password: valuess?.password,
    conformpassword: valuess?.conformpassword,
    country_code: valuess?.country_code || selectCountryCode || "+966",
    country_id: valuess?.country_id,
    agree: valuess?.agree || false,
    image: valuess?.image || statevalues?.profile_image || statevalues?.image || null,
  };

  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  const handleSubmit = async (values) => {
    setLoading(true);

    let imageUrl = "";
    if (values.image && values.image instanceof File) {
      try {
        imageUrl = await uploadImage(values.image);
      } catch (error) {
        urtoast("Failed to upload image", 2);
        setLoading(false);
        return;
      }
    }
    else if (isHttpImageUrl(values.image)) {
      try {
        imageUrl = await uploadRemoteImage(values.image, "social-profile");
      } catch (error) {
        urtoast("Failed to upload profile image", 2);
        setLoading(false);
        return;
      }
    }
    else if (statevalues?.profile_image || statevalues?.image) {
      const socialImageUrl = statevalues.profile_image || statevalues.image;

      if (isHttpImageUrl(socialImageUrl)) {
        try {
          imageUrl = await uploadRemoteImage(socialImageUrl, "social-profile");
        } catch (error) {
          urtoast("Failed to upload profile image", 2);
          setLoading(false);
          return;
        }
      } else {
        imageUrl = socialImageUrl;
      }
    }

    const data = {
      ...values,
      profile_image: imageUrl,
      reg_from: "1",
      social_id: statevalues?.social_id || "",
      social_from: statevalues?.social_from || "",
      social_token: statevalues?.social_token || "",
    };

    // NEW: If email is pre-populated from state (disabled/verified), remove it from payload
    // if (statevalues?.email_id) {
    //   delete data.email_id;
    // }

    if (isWhatsappRef.current === 1) {
      data.is_whatsapp = 1;
    }

    checkMobile(data)
      .then((res) => {
        if (res.data.status) {
          urtoast(res.data.response.message, 2);
        } else {
          sendOTP(data)
            .then((res) => {
              if (res.data.status) {

                // NEW: Adjust toast message dynamically so it makes sense to the user
                const toastMessage = statevalues?.email_id
                  ? `OTP has been sent to the Mobile number ${values.country_code} ${values.mobile_number}`
                  : `OTP has been sent to the Mobile number ${values.country_code} ${values.mobile_number} and Email ID ${values.email_id}`;

                urtoast(toastMessage, 1);

                setNextpage(false);
                setValuess(data);
                scrollToTop();
              } else {
                urtoast(res.data.response.message, 2);
              }
            })
            .catch((e) => {
              urtoast(e.message, 2);
            });
        }
      })
      .catch((e) => {
        urtoast(e.message, 2);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  if (!countrylist) {
    return null;
  }

  return (
    <>
      {nextpage ? (
        <div className="mx-auto register">
          <h1 className="heading">Sign up to get started</h1>
          <Signuptogetstarted />

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ errors, formik, values, touched, setFieldValue }) => (
              <Form autoComplete="on">
                <div className="col-md-12 form-sec">
                  <ProfileImageUpload
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                    setFieldValue={setFieldValue}
                    initialImage={values?.image}
                  />
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label htmlFor="first_name">First Name <AsteriskLabel /></label>
                      <Field
                        type="text"
                        id="first_name"
                        name="first_name"
                        className="form-control"
                        placeholder="Enter first name"
                        onKeyDown={handleNameKeyDown}
                      />
                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="error"
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="last_name">Last Name <AsteriskLabel /></label>
                      <Field
                        type="text"
                        id="last_name"
                        name="last_name"
                        className="form-control"
                        placeholder="Enter last name"
                        onKeyDown={handleNameKeyDown}
                      />
                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="email_id">Email ID <AsteriskLabel /></label>
                      <Field
                        type="email"
                        id="email_id"
                        name="email_id"
                        className="form-control"
                        placeholder="Enter email ID"
                        disabled={statevalues?.email_id}
                      />
                      <ErrorMessage
                        name="email_id"
                        component="div"
                        className="error"
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <PhoneInputforSignUp
                        errors={errors}
                        formik={formik}
                        values={values}
                        touched={touched}
                        setFieldValue={setFieldValue}
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="password">Password <AsteriskLabel /></label>
                      <div className="password-btn">
                        <Field
                          onKeyDown={notallowspace}
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          className="form-control"
                          placeholder="Password (8 or more characters)"
                        />
                        <span
                          onClick={togglePasswordVisibility}
                          className="btn"
                        >
                          {showPassword ? (
                            <i className="fa-solid fa-eye" aria-hidden="true"></i>
                          ) : (
                            <i className="fa-solid fa-eye-slash"></i>
                          )}
                        </span>
                      </div>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="conformpassword">Repeat Password <AsteriskLabel /></label>
                      <div className="password-btn">
                        <Field
                          onKeyDown={notallowspace}
                          type={showPassword1 ? "text" : "password"}
                          id="conformpassword"
                          name="conformpassword"
                          className="form-control"
                          placeholder="Repeat password"
                        />
                        <span
                          onClick={togglePasswordVisibility1}
                          className="btn"
                        >
                          {showPassword1 ? (
                            <i className="fa-solid fa-eye" aria-hidden="true"></i>
                          ) : (
                            <i className="fa-solid fa-eye-slash"></i>
                          )}
                        </span>
                        <ErrorMessage
                          name="conformpassword"
                          component="div"
                          className="error"
                        />
                      </div>
                    </div>

                    <div className="col-md-12 form-group">
                      <label htmlFor="country_id"> Country <AsteriskLabel /></label>

                      <ReactSelect
                        options={
                          Array.isArray(countrylist) &&
                          countrylist.map((country) => ({
                            value: country.id,
                            label: country.title,
                          }))
                        }
                        placeholder="Select country"
                        value={selectCountry}
                        onChange={(option) => {
                          setSelectCountry(option);
                          setFieldValue("country_id", option.value);
                        }}
                      />
                      <ErrorMessage
                        name="country_id"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-10 form-group ">
                      <div className="input-check">
                        <input
                          type="checkbox"
                          onClick={() => {
                            setModal(true);
                            setFieldValue("agree", false);
                          }}
                          id="agree"
                          name="agree"
                          checked={values.agree}
                        />
                        <label htmlFor="agree">
                          Yes, I understand and agree to Urxprt's
                          <span>Terms of Service</span>, including the
                          <span> User Agreement</span> and
                          <span> Privacy Policy</span> and
                          <span> EULA</span>.
                        </label>
                      </div>
                      <ErrorMessage
                        name="agree"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-12 last-form">
                      <div className="d-flex" style={{ columnGap: "10px", flexWrap: "wrap", marginBottom: "15px" }}>
                        <button
                          type="submit"
                          className="btn create-account flex-grow-1"
                          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', columnGap: "10px" }}
                          disabled={loading}
                          onClick={() => {
                            isWhatsappRef.current = 0;
                          }}
                        >
                          {loading ? (
                            <LoginLoaderButton />
                          ) : (
                            <>
                              <img src={messageicon} alt="" /> Verify via SMS
                            </>
                          )}
                        </button>

                        <button
                          type="submit"
                          className="btn create-account flex-grow-1"
                          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', columnGap: "10px", background: "#1DAA61" }}
                          disabled={loading}
                          onClick={() => {
                            isWhatsappRef.current = 1;
                          }}
                        >
                          {loading ? (
                            <LoginLoaderButton />
                          ) : (
                            <>
                              <img src={whatsappicon} alt="" /> Verify via WhatsApp
                            </>
                          )}
                        </button>
                      </div>
                      <p>
                        Already have an account?{" "}
                        <a
                          style={loading ? disabledStyle : { cursor: "pointer" }}
                          onClick={() => !loading && navigate(`/${lan}/loginwithemail`)}
                        >
                          {" "}
                          Login
                        </a>
                      </p>
                    </div>
                  </div>
                  {modal && (
                    <Modal
                      isOpen={modal}
                      keyboard={false}
                      modalClassName="ter-over"
                      className="modal-width modal-centered popupmodal termsconditionmodal "
                    >
                      <PopupPrivacyPolicy
                        setFieldValue={setFieldValue}
                        setModal={setModal}
                      />
                    </Modal>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        <VerifyEmailMobile valuess={valuess} setNextpage={setNextpage} />
      )}
    </>
  );
}
